/* Lives inside the item-page header bar, pushed to the right edge */
.component {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  margin-right: 12px;
}

.regressionBadge {
  padding: 1px 8px;
  font-size: 11px;
  line-height: 16px;
  white-space: nowrap;
  color: var(--fully-white);
  background-color: var(--warm-pink);
  border-radius: 9px;
}

.label {
  font-size: 12px;
  color: var(--brown-grey);
  white-space: nowrap;
}
